import { SessionState } from '@lendi/lala-react';
import { BaseEvent, EventCategory } from '@lendi/analytics-web';
import { WebAnalyticsWrapped, createWebAnalytics } from './createWebAnalytics';

interface CustomEvent extends BaseEvent {
  question?: string;
  answer?: string;
  position?: string;
  text?: string;
}

class TrackingService {
  private analytics: WebAnalyticsWrapped;

  constructor(category: EventCategory, session?: SessionState) {
    this.analytics = createWebAnalytics(category, session);
  }

  async trackPage(name: string) {
    await this.analytics.trackPageLoad(name);
  }

  async trackEvent<T extends BaseEvent>(event: T) {
    await this.analytics.trackEventOccurred(event);
  }

  async trackCustomEvent<T extends CustomEvent>(event: T) {
    await this.analytics.trackEventOccurred(event);
  }

  async identityTracking(customerId?: string, flags?: any, userTraits?: any) {
    await this.analytics.trackCustomer(customerId, flags, userTraits);
  }
}

export const trackingService = new TrackingService(EventCategory.BOOK_APPOINTMENT);
